import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabaseClient';
import PasswordInput from '../components/PasswordInput';

const ResetPasswordPage = () => {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleReset = async () => {
    setError('');
    if (password.length < 6) {
      setError('Password must be at least 6 characters.');
      return;
    }
    if (password !== confirmPassword) {
      setError('Passwords do not match.');
      return;
    }
    setLoading(true);
    const { error: updateError } = await supabase.auth.updateUser({ password });
    setLoading(false);
    if (updateError) {
      setError(updateError.message);
    } else {
      setSuccess(true);
      setTimeout(() => navigate('/oss-sntm'), 2500);
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: 'var(--dark)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ background: 'var(--dark-3)', border: '1px solid rgba(201,168,76,0.2)', borderRadius: '8px', padding: '48px', width: '100%', maxWidth: '400px' }}>
        <h1 className="serif" style={{ color: 'var(--gold)', fontSize: '28px', fontWeight: 300, marginBottom: '8px' }}>Set New Password</h1>
        <p style={{ color: 'var(--text-muted)', fontSize: '13px', marginBottom: '32px' }}>One Stop Shop — Admin</p>

        {success ? (
          <p style={{ color: '#4ade80', fontSize: '14px' }}>✅ Password updated! Redirecting to admin login...</p>
        ) : (
          <>
            <PasswordInput value={password} onChange={setPassword}
              placeholder="New password"
              style={{ marginBottom: '16px' }} />
            <PasswordInput value={confirmPassword} onChange={setConfirmPassword}
              placeholder="Confirm new password"
              onEnter={handleReset}
              style={{ marginBottom: '16px' }} />
            {error && <p style={{ color: '#f87171', fontSize: '13px', marginBottom: '16px' }}>{error}</p>}
            <button onClick={handleReset} className="btn-primary" style={{ width: '100%' }} disabled={loading}>
              {loading ? 'Updating...' : 'Update Password'}
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default ResetPasswordPage;
